import React, { FC, useEffect, useState } from 'react';
import PrintOpenModal from "@components/Print/PrintOpenModal";
import SpecialResearchGrantPreview from "@/modules/UserPanel/components/Grant/Application/SpecialResearchGrant/Content/SpecialResearchGrant.preview";
import {
  CorePaymentHistoryApi,
  SpecialResearchGrantApplicationApi
} from "@/api";
import {useErrorHandler} from "@/hooks/useErrorHandler";

const initialState = {
    itemData: {id: null},
    piResearcherProfileData: {id: null},
    aiResearcherProfileData: {id: null},
    paymentData: { id: null, status:null, amount: null, ekpay_transaction_id: null, ekpay_challan_trx_id: null, challan_amount: null, challan_date: null },
    loading: false,
}

const SpecialResearchGrantPreviewLoader: FC<any> = props => {
    const { applicationId } = props;
    const [itemData, setItemData] = useState<any>(initialState.itemData);
    const [piResearcherProfileData, setPiResearcherProfileData] = useState<any>(initialState.piResearcherProfileData);
    const [aiResearcherProfileData, setAiResearcherProfileData] = useState<any>(initialState.aiResearcherProfileData);
    const [loading, setLoading] = useState(initialState.loading);

    const [paymentData, setPaymentData] = useState<any>(initialState.paymentData);
    const [loadingPaymentData, setLoadingPaymentData] = useState(false);

    const { handleErrorMessage, handleSuccessMessage, showErrorMessage } = useErrorHandler();

    useEffect(() => {
        if (applicationId) {
          loadSpecialResearchGrantData();
        }
    }, [applicationId])

    useEffect(() => {
      if (itemData.id) {
        loadApplicationPaymentInfo();
      }
    }, [itemData.id]);

  const loadSpecialResearchGrantData = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      SpecialResearchGrantApplicationApi.getById(applicationId)
        .then(res => {
          setItemData(res.data.data);
          setPiResearcherProfileData(res.data.data?.pi_application_profile || initialState.piResearcherProfileData);
          setAiResearcherProfileData(res.data.data?.ai_application_profile || initialState.aiResearcherProfileData);
          setLoading(false);
          resolve(res);
        })
        .catch(err => {
          handleErrorMessage(err);
          setLoading(false);
          reject(err);
        });
    });
  }

  const loadApplicationPaymentInfo = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      setLoadingPaymentData(true);
      const payload = {
        record_id: itemData.id,
        record_type: 'SPECIAL_RESEARCH_GRANT_APPLICATION_FEE',
        service_id: itemData.service_id,
        status: ['PENDING', 'APPROVED'],
      }
      CorePaymentHistoryApi.paymentHistoryByRecordInfo(payload)
        .then(res => {
          setPaymentData(res.data.data);
          setLoadingPaymentData(false);
          resolve(res);
        })
        .catch(err => {
          setLoadingPaymentData(false);
          reject(err);
        });
    });
  }

    return (
      <PrintOpenModal
        loading={loading}
        btnText={"View Application"}
        btnType={"button"}
        btnClass={"btn btn-dark mb-2 btn-color-one"}
        modalBtnText={"Print"}
        modalTitle={"Print Preview"}
        applicationData={itemData}
        loadingPaymentData={loadingPaymentData}
        paymentData={paymentData}
        piResearcherProfileData={piResearcherProfileData}
        aiResearcherProfileData={aiResearcherProfileData}
        component={SpecialResearchGrantPreview}
      />
    );
}

export default React.memo(SpecialResearchGrantPreviewLoader);
